module.exports = __webpack_public_path__ + "img/fish4.8d894220.png";